import React, { useRef, useCallback } from "react";

/**
 * Props:
 *  • onUpload: (url:string)  — called once upload succeeds, with the public URL
 *  • children: ReactNode     — the button (or any UI) that triggers the picker
 */
export default function ImageUploader({ onUpload, children }) {
  const fileInputRef = useRef(null);

  const handleClick = useCallback(() => {
    fileInputRef.current?.click();
  }, []);

  const handleChange = useCallback(
    (e) => {
      const file = e.target.files?.[0];
      if (!file) return;

      const reader = new FileReader();
      reader.onload = async (event) => {
        const dataUrl = event.target.result;
        onUpload(dataUrl);
        e.target.value = "";
      };
      reader.onerror = () => {
        /* handle read error if you like */
        e.target.value = "";
      };

      reader.readAsDataURL(file);
    },
    [onUpload]
  );

  return (
    <>
      <input
        ref={fileInputRef}
        type="file"
        accept="image/*"
        className="hidden"
        onChange={handleChange}
      />
      <div
        onClick={handleClick}
        style={{ display: "inline-block", cursor: "pointer" }}
      >
        {children}
      </div>
    </>
  );
}
